"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const map_component_1 = require("../../map.component");
const _4d_mapper_1 = require("4d-mapper");
const map_service_1 = require("../../../../commons/map.service");
const app_service_1 = require("../../../../commons/app.service");
const BaseComponent_1 = require("../../../../commons/BaseComponent");
const global_1 = require("../../../../commons/global");
const entity_helper_service_1 = require("../../../../service/entity-helper.service");
const application_events_service_1 = require("../../../../xs/services/events/application-events.service");
const Cesium = window.Cesium;
class AgroListComponent extends BaseComponent_1.BaseComponent {
    constructor(route, router, fourD, snackBar, dialog, entityHelper, mapService, service, applicationEvents) {
        super(router, snackBar, dialog);
        this.route = route;
        this.router = router;
        this.fourD = fourD;
        this.entityHelper = entityHelper;
        this.mapService = mapService;
        this.service = service;
        this.checkAllOpts = {};
        this.plots = {};
        console.log('agro.component CONSTRUCTOR', this);
    }
    init() {
        this.addSubscription('onAnnotationsChange', this.mapService.onAnnotationsChange().subscribe(s => {
            var agros = this.mapService.annotations.filter(a => a['annotationMode'] == 'agronomeye');
            this.sensors = agros.filter(a => a['category'] == 'sensors');
            this.stations = agros.filter(a => a['category'] == 'weatherStations');
            this.allAnnots = agros;
            agros.forEach(a => this.plots['' + a.id] = true);
            this.checkAllOpts = {
                weatherStations: true,
                sensors: true
            };
        }));
    }
    clickedMap(movement, rightClick, checkedPosition) {
        console.log('agro.comp :: clickedMap()');
        var feature = this.mapService.viewer.scene.pick(movement.position);
        var def = Cesium.defined(feature);
        if (def && !feature.content && feature.id.fourd_ref) {
            var newSelect = this.mapService.annotations.find(a => a.id == feature.id.fourd_ref);
            this.mapComp.inspectorComp.setSelected(newSelect);
        }
        else {
            // if details tab is open....
            if (this.mapComp.detailsNav.opened && rightClick) {
                this.mapComp.inspectorComp.setSelected(null, false);
                this.router.navigate([this.fourD.activeUser ? '/app/projects/map' : '/map', this.mapService.currentProject.id, 'agro']);
            }
            else {
                this.mapComp.inspectorComp.setSelected(null, false);
                if (!rightClick) {
                    this.router.navigate([
                        this.fourD.activeUser ? '/app/projects/map' : '/map',
                        this.mapService.currentProject.id, 'geojson',
                        Cesium.Math.toDegrees(this.mapComp.currentCoord.position.latitude),
                        Cesium.Math.toDegrees(this.mapComp.currentCoord.position.longitude)
                    ]);
                    return map_component_1.ClickDisplay.Chevron;
                }
            }
        }
    }
    agroToggle(a) {
        this.mapComp.detailsNav.close();
        if (this.plots['' + a.id])
            this.mapService.helper.addPlottable(a).subscribe(res => res.object.pin.billboard.image = this.entityHelper.getPinImage(res.plottable));
        else
            this.mapService.helper.removePlottable(a);
    }
    becameActive(mapComp) {
        this.mapComp = mapComp;
        var agros = this.mapService.annotations.filter(a => a['annotationMode'] == 'agronomeye');
        agros.forEach(a => this.agroToggle(a));
    }
    becameInactive(mapComp) {
        var agros = this.mapService.annotations.filter(a => a['annotationMode'] == 'agronomeye');
        agros.forEach(a => this.mapService.helper.removePlottable(a));
    }
    refreshSensors() {
        var apiType = this.mapService.fourD.apis.find(a => a.processorImpl == global_1.APITypes.Agronomeye.IMPL);
        apiType.saveObservable().subscribe(_ => this.fourD.V.api('/remote/' + apiType.id + '/test').subscribe(s => {
            this.mapService.refreshAnnotations().subscribe(s => this.openSnackBarSuccess('MAP.SYNC_MSG'));
        }, e => this.openSnackBarError('GENERIC.CONNECT_ERROR2' + e)));
    }
    checkAll(s) {
        this.checkAllOpts[s] = !this.checkAllOpts[s];
        if (this.checkAllOpts[s]) {
            this.allAnnots.filter(a => a['category'] == s).forEach(a => this.mapService.helper.addPlottable(a).subscribe(res => res.object.pin.billboard.image = this.entityHelper.getPinImage(res.plottable)));
        }
        else {
            this.allAnnots.filter(a => a['category'] == s).forEach(a => this.mapService.helper.removePlottable(a));
        }
    }
}
exports.AgroListComponent = AgroListComponent;
